import React from "react"
import Dropzone from "react-dropzone"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { BodyLarge, BodySmall } from "components/views/atoms/Bodies"
import { CircleImage } from "components/views/atoms/images/CircleImage"
import L10n from "lib/carrot-l10n"
import { AcceptableFileExtensions } from "components/views/reimbursements/upload/AcceptableFileExtensions"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const CloudImage = ({ dragging, small }) => (
  <CircleImage
    size={small ? 54 : 96}
    padding={small ? 12 : 18}
    className="animate-all-slow"
    backgroundColor={dragging ? "coral" : "cornflower-blue"}
    iconName="icn-cloud-upload"
  />
)

const FileSizeLimitLabel = () => (
  <div style={{ maxWidth: 309 }}>
    <Spacer height={0.25} />
    <BodySmall color="black-60">{l`client.reimbursements.maxFileSize`}</BodySmall>
  </div>
)

const DropzoneIllustration = ({ draggingFile, small }) => (
  <div className="flex flex-column justify-center items-center h-100">
    <FlexRowCenter>
      <CloudImage dragging={draggingFile} small={small} />
    </FlexRowCenter>
    <Spacer height={1} />
    <BodyLarge>
      <span className="dn db-ns">
        {draggingFile ? l`client.reimbursements.dropFilesHere` : l`client.reimbursements.dragFilesHere`}
      </span>
      <span className="dn-ns db">{l`client.reimbursements.tapToBrowse`}</span>
    </BodyLarge>
    {!draggingFile ? <FileSizeLimitLabel /> : <Spacer height={1.3} />}
  </div>
)

const UploadDropzoneWithIllustration = ({ small, draggingFile, onDropAccepted, onDropRejected }) => {
  const draggingBorder = draggingFile ? "ba bw1 b--carrot-orange" : "ba bw1 b--moon-gray"

  return (
    <Dropzone
      multiple
      onDropAccepted={onDropAccepted}
      onDropRejected={onDropRejected}
      accept={AcceptableFileExtensions}
    >
      {({ getRootProps, getInputProps }) => (
        <div
          className={`
          bg-light-gray w-100 br3 pointer no-outline tc lh-solid ph3 animate-all-slow ${
            small ? "pv35" : "pv5"
          } ${draggingBorder}`}
          {...getRootProps()}
        >
          {draggingFile ? <div className="fullscreen-dropzone-overlay" /> : ""}

          <input id="upload-files-input" {...getInputProps()} />

          <DropzoneIllustration draggingFile={draggingFile} small={small} />
        </div>
      )}
    </Dropzone>
  )
}

export { UploadDropzoneWithIllustration }
